/* @flow */

export class PasswordExpiryNotificationActions {
    static DO_IT_LATER = 'PASSWORD_EXPIRY_NOTIFICATION_DO_IT_LATER';
    static SET_VISIBILITY = 'PASSWORD_EXPIRY_NOTIFICATION_SET_VISIBILITY';

    static doItLater = (clientId: string, personnelId: string) => {
        return {
            type: PasswordExpiryNotificationActions.DO_IT_LATER,
            payload: {
                clientId,
                personnelId,
                timestamp: new Date()
            }
        };
    };

    static show = (clientId: string, personnelId: string) => {
        return {
            type: PasswordExpiryNotificationActions.SET_VISIBILITY,
            payload: {
                clientId,
                personnelId,
                visible: true
            }
        };
    };

    static hide = (clientId: string, personnelId: string) => {
        return {
            type: PasswordExpiryNotificationActions.SET_VISIBILITY,
            payload: {
                clientId,
                personnelId,
                visible: false
            }
        };
    };
}
